import React, { Component } from "react";

import positive from "./img/p-plus-4.svg";
import negative from "./img/p-minus-2.svg";

import styles from "./style.module.scss";

export class Ideal57 extends Component {
  render() {
    return (
      <div className={styles.results}>
        <div className={styles.results__ideal}>
          <h4 tabIndex={0}>{"Ideal results"}</h4>
          <div className={styles.results__ideal__result}>
            <p tabIndex={0}>
              {
                "For successful transformation, the circular plasmid DNA needs to be taken up into the bacterial cells."
              }
            </p>
            <img
              tabIndex={0}
              draggable="false"
              src={positive}
              alt={"P+ tube containing plasmids inside bacteria."}
            />
            <img
              tabIndex={0}
              draggable="false"
              src={negative}
              alt={"P- tube containing only bacteria."}
            />
            <p tabIndex={0}>
              {"The negative control contains competent "} <i>{"E. coli"}</i>{" "}
              {
                "cells, but no plasmids, so the bacterial cells cannot be transformed."
              }
            </p>
          </div>
        </div>
      </div>
    );
  }
}
